module.exports = "mutation ($personId: ID!, $input: CareerInput) {\n    personEditCareer(person_id: $personId, input: $input) {\n        id\n    }\n}\n"